import { render, staticRenderFns } from "./button-group-vertical-two.mpx?vue&type=template&id=ec5bd3e2&isComponent&outputPath=components%2Fbutton-group-vertical-two21f186f6%2Findex"
import script from "./button-group-vertical-two.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbutton-group-vertical-two21f186f6%2Findex"
export * from "./button-group-vertical-two.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbutton-group-vertical-two21f186f6%2Findex"
import style0 from "./button-group-vertical-two.mpx?vue&type=style&index=0&id=ec5bd3e2&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_21f186f6%22%7D&isComponent&outputPath=components%2Fbutton-group-vertical-two21f186f6%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports